// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2FIHb","inputDescription":"styles_inputDescription__21LA-"};